/* eslint-disable no-irregular-whitespace */
// material ui components
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

// libraries
import classNames from "classnames";

import {
  BUYER,
  NAME,
  SECOND_STEP_DESCRIPTION_2,
  SECOND_STEP_HEADER,
  SECOND_STEP_HEADER_2,
  SECOND_STEP_HEADER_3,
} from "../constants";

// styles
import styles from "../styles.module.css";
import "../index.css";
import { OnboardingType } from "../onboarding";

interface Props {
  type: OnboardingType;
}

const Second = ({ type = OnboardingType.LARGE }: Props) => {
  return (
    <Box className={styles.container}>
      <Box
        className={classNames(
          styles.image_wrapper,
          type === OnboardingType.SMALL && styles.image_wrapper_smaller
        )}>
        <Box component="img" src="/assets/images/onboarding-two.png" />
      </Box>
      <Box className={styles.text_wrapper}>
        <Typography
          className={classNames(
            styles.onboardingText,
            type === OnboardingType.SMALL && styles.onboardingSmaller
          )}
          variant="h1">
          {SECOND_STEP_HEADER_3}
        </Typography>
        {type === OnboardingType.LARGE && (
          <Typography className={styles.onboardingText} variant="body1">
            {SECOND_STEP_DESCRIPTION_2}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Second;
